<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-header-actions">

                          <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                            <div class="row align-items-end">
                              <div class="col-12 col-sm-6 card-header-search-box">
                                <div class="input-group">
                                    <input class="form-control search-input" type="text" :placeholder="$t('main.search')" v-model="filter.search" @keypress.enter="initList">
                                    <div class="input-group-append">
                                        <button class="all-btn search-btn" @click="initList">
                                            <i class="fa fa-search"></i>
                                        </button>
                                    </div>
                                </div>
                              </div>
                              <div class="col-12 col-sm-6 card-header-search-box mt-2 mt-sm-0">
                                <div>
                                  <label>Кадастр рақами</label>
                                  <cadastre-input :cadastre-number.sync="filter.cadastreDocNumber"/>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                            <div class="row align-items-end">
                              <div class="col-12 col-sm-6 card-header-select-box mt-2 mt-sm-0">
                                <div class="form-group">
                                  <label class="text-gray">{{$t("main.searchStatus")}}</label>
                                  <div class="position-relative">
                                    <select class="form-control"
                                            v-model="filter.status"
                                            @change="onChangeStatus">
                                      <option value=""></option>
                                      <option value="Pending">{{$t("realEstate.status.pending")}}</option>
                                      <option value="AssignedToEvaluator">{{$t("realEstate.status.assignedToEvaluator")}}</option>
                                      <option value="NotFullyEvaluated">{{$t("realEstate.status.notFullyEvaluated")}}</option>
                                      <option value="Evaluated">{{$t("realEstate.status.evaluated")}}</option>
                                      <option value="Confirmed">{{$t("realEstate.status.confirmed")}}</option>
                                      <option value="Rejected">{{$t("realEstate.status.rejected")}}</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div class="col-12 col-sm-6 card-header-select-box mt-2 mt-sm-0">
                                <div class="form-group">
                                  <label class="text-gray">{{$t('newRealEstate.field.plus.source')}}</label>
                                  <div class="position-relative">
                                    <select class="form-control"
                                            v-model="sourceByFilter">
                                      <option value=""></option>
                                      <option value="ONLINE">{{$t("realEstate.createType.online")}}</option>
                                      <option value="ONLINE_PLUS">{{$t("realEstate.createType.online_plus")}}</option>
                                      <option value="REAL_SOFT">{{$t("realEstate.createType.real_soft")}}</option>
                                      <option value="INSIDE">{{$t("realEstate.createType.ourselves")}}</option>
                                      <option value="API_BANK">{{$t("realEstate.createType.api_bank")}}</option>
                                      <option value="API_MIB">{{$t("realEstate.createType.apiMib")}}</option>
                                      <option value="EXPERT2">{{$t("realEstate.createType.expert2")}}</option>
                                      <option value="API_EXARID">{{$t("realEstate.createType.api_exarid")}}</option>
                                      <option value="ANDROID">{{$t("realEstate.createType.android")}}</option>
                                      <option value="API_E_MONITORING">{{$t("realEstate.createType.apiEMonitoring")}}</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                            <div class="row align-items-end">
                              <div class="col-12 col-sm-6 card-header-select-box mt-2 mt-sm-0">
                                <div class="form-group">
                                  <label>{{$t('client.field.province')}}</label>
                                  <v-select
                                      label="name"
                                      v-model="province"
                                      :filterable="false"
                                      :options="provinces"
                                      @search="onProvinceSearch"
                                      @search:focus="onProvinceFocus"
                                      @change="onChangeFilterProvince"
                                  >
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                  </v-select>
                                </div>
                              </div>
                              <div class="col-12 col-sm-6 card-header-select-box mt-2 mt-sm-0">
                                <div class="form-group">
                                  <label>{{$t('client.field.region')}}</label>
                                  <v-select
                                      label="name"
                                      v-model="region"
                                      :filterable="false"
                                      :options="regions"
                                      @search="onRegionSearch"
                                      @search:focus="onRegionFocus"
                                      @change="onChangeFilterRegion"
                                  >
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                  </v-select>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                            <div class="row align-items-end">

                              <div class="col-12 col-sm-6 card-header-select-box mt-2 mt-sm-0">
                                <div class="form-group">
                                  <label>{{$t("report.date.startDate")}}</label>
                                  <date-picker
                                      class="form-control"
                                      format="dd/MM/yyyy"
                                      v-model="filterStartDate"
                                      :clear-button="true"
                                  ></date-picker>
                                </div>
                              </div>

                              <div class="col-12 col-sm-6 card-header-select-box mt-2">
                                <div class="form-group">
                                  <label>{{$t("report.date.endDate")}}</label>
                                  <date-picker
                                      class="form-control"
                                      format="dd/MM/yyyy"
                                      v-model="filterEndDate"
                                      :clear-button="true"
                                  ></date-picker>
                                </div>
                              </div>

                            </div>
                          </div>

                          <div class="col-12 justify-content-md-end mt-2 card-header-btns-box">
                            <label class="mr-3 mt-3" v-if="results && results.total">Жами: {{results.total}}</label>
                            <div class="d-flex flex-wrap" style="gap: 6px;">
                              <router-link tag="button" class="all-btn add-btn" :to="addRealEstateUrl" v-if="hasPermission('NEW_REAL_ESTATE_ADD')">
                                {{$t("action.add")}}
                              </router-link>
                              <button class="all-btn" @click="handleSignDirectorEsp" v-if="canSignDirectorEsp">
                                Директор ЭЦП
                              </button>
                            </div>
                            <!--<router-link tag="button" class="all-btn pull-right mr-3" :to="'/new-real-estate/cadastre-api/test'">-->
                            <!--Кадастр АПИни текшириш-->
                            <!--</router-link>-->
                          </div>
                        </div>
                    </div>
                    <div class="card-body table-responsive">
                        <div class="table-wrapper">
                          <table class="table table-hover">
                            <thead>
                            <tr>
                              <th>ID</th>
                              <th width="15%">{{$t("newRealEstate.field.plus.category")}}</th>
                              <th width="15%">{{$t("newRealEstate.field.plus.createdBy")}}</th>
                              <th width="10%" class="text-center">{{$t("realEstate.field.status")}}</th>
                              <th class="text-center">Вилоят | туман | микротуман</th>
                              <th class="text-center">Ёндашувлар</th>
                              <th>1м2 ер нархи</th>
                              <th>1м2 бино нархи</th>
                              <th>Баҳоланган қиймат</th>
                              <th width="10%">Тасдиқлаш бахоловчи</th>
                              <th width="10%">Тасдиқлаш директор</th>
                              <th class="text-center" v-if="hasPermission('NEW_REAL_ESTATE_VIEW') || hasPermission('NEW_REAL_ESTATE_EDIT')">
                                {{$t("realEstate.field.action")}}
                              </th>
                            </tr>
                            </thead>
                            <tbody v-if="!loading && results && results.data">
                            <tr v-for="result in results.data" :key="result.id">
                              <td class="text-center">
                                <div>
                                  {{result.id}}
                                  <button class="all-btn delete-btn table-action"
                                          @click="getAndSendFixError(result)"
                                          v-if="isCadastreFixError(result)"
                                          v-tooltip="'Кадастр маълумоти топилмаган. Холатни билиш учун босинг.'"
                                          :disabled="processing"
                                  >
                                    <i class="fa fa-search-minus"></i>
                                  </button>
                                </div>
                              </td>
                              <td>
                                  <div class="font-weight-bold">{{result.name}}</div>
                                   <div class="text-secondary">{{result.cadastreDocNumber}}</div>
                                  <div class="text-secondary">
                                      <span class="font-weight-bold">{{$t("newRealEstate.field.plus.buildingType")}}:</span> {{getBuildingType(result)}}
                                      <span v-if="result.subBuildingType">{{getSubBuildingType(result)}}</span>
                                  </div>
                                  <div v-if="result.evlAmountToPay && result.evlAmountToPay > 0" class="font-italic">
                                    <div v-if="result.evlTaxPercent > 0">
                                      Контракт суммаси + НДС({{result.evlTaxPercent | currency('', 0, { thousandsSeparator: ' ' })}}%): {{result.evlAmountToPay | currency('', 0, { thousandsSeparator: ' ' })}} сўм
                                    </div>
                                    <div v-else>
                                      Контракт суммаси: {{result.evlAmountToPay | currency('', 0, { thousandsSeparator: ' ' })}} сўм
                                    </div>
                                    Тўланган сумма: {{result.paidAmount | currency('', 0, { thousandsSeparator: ' ' })}} сўм<br/>
                                    <div class="badge badge-success" v-if="result.paidAmount >= result.evlAmountToPay">Тўланган</div>
                                    <div class="badge badge-warning" v-else-if="result.paidAmount > 0">Қисман тўланган</div>
                                    <div class="badge badge-danger" v-else>Тўланмаган</div>
                                  </div>
                              </td>
                              <td width="10%">
                                <template v-if="result.createdBy">
                                  <div>
                                    <span class="text-secondary">{{result.createdBy.name}}</span>
                                  </div>
                                  <div class="text-info"></div>
                                </template>
                                <template>
                                  <span class="font-weight-bold">Буюртмачи: </span>
                                  <span class="text-secondary" v-html="ownerName(result)"></span>
                                </template>
                                <div v-if="result.owner">
                                  <span class="font-weight-bold">Мулк эгаси: </span>
                                  <span class="text-secondary">{{result.owner.fullName}}</span>
                                  <div class="text-warning">{{result.owner.firmName}}</div>
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="badge badge-secondary" v-if="result.status==='AssignedToEvaluator'">{{$t("realEstate.status.assignedToEvaluator")}}</div>
                                <div class="badge badge-warning" v-else-if="result.status==='NotFullyEvaluated'">{{$t("realEstate.status.notFullyEvaluated")}}</div>
                                <div class="badge badge-info" v-else-if="result.status==='Evaluated'">{{$t("realEstate.status.evaluated")}}</div>
                                <div class="badge badge-success" v-else-if="result.status==='Confirmed'">{{$t("realEstate.status.confirmed")}}</div>
                                <div class="badge badge-danger" v-else-if="result.status==='Rejected'">{{$t("realEstate.status.rejected")}}</div>
                                <div class="badge badge-danger" v-else-if="result.status==='Pending'">{{$t("realEstate.status.pending")}}</div>
                                <div class="badge badge-danger" v-else-if="result.status==='SentToComplement'">{{$t("realEstate.status.sentToComplement")}}</div>
                                <div class="badge badge-danger" v-else-if="result.status==='InIdentification'">{{$t("realEstate.status.inIdentification")}}</div>
                                <div class="badge badge-danger" v-else-if="result.status ==='ErrorInPrice'">{{$t("realEstate.status.errorInPrice")}}</div>
                                <div class="badge badge-warning" v-else-if="result.status==='Open'">{{$t("realEstate.status.open")}}</div>
                                <div class="badge badge-primary" v-else-if="result.status==='InCorrection'">{{$t("realEstate.status.inCorrection")}}</div>
                                <div class="text-secondary" v-if="result.confirmedDate && result.status==='Confirmed'">{{result.confirmedDate}}</div>
                                <div class="text-secondary" v-else-if="result.assignedToEvaluatorDate && result.status==='AssignedToEvaluator'">
                                  {{result.assignedToEvaluatorDate}}
                                </div>
                                <div class="text-info" v-else-if="result.status ==='Evaluated'">{{result.evlEstimatedDate}}</div>
                                <div class="text-info" v-else-if="result.status ==='Pending'"><span v-if="result.pendingDate">{{new Date(result.pendingDate) | dateFormat('DD/MM/YYYY HH:mm')}}</span></div>
                                <div class="text-info" v-else-if="result.status ==='Rejected' || result.status==='NotFullyEvaluated'">{{new Date(result.updatedDate) | dateFormat('DD/MM/YYYY HH:mm')}}</div>

                                <div>Бинолар сони: <span class="badge badge-info">{{result.buildings && result.buildings.length}}</span></div>

                                <div v-if="result.source === 'INSIDE'" class="badge badge-info">{{$t("realEstate.createType.ourselves")}}</div>
                                <div v-if="result.source === 'ONLINE'" class="badge badge-secondary">{{$t("realEstate.createType.online")}}</div>
                                <div v-if="result.source === 'ONLINE_PLUS'" class="badge badge-secondary">{{$t("realEstate.createType.online_plus")}}</div>
                                <div v-if="result.source === 'API_MIB'" class="badge badge-warning">{{$t("realEstate.createType.apiMib")}}</div>
                                <div v-if="result.source === 'ANDROID'" class="badge badge-warning">{{$t("realEstate.createType.android")}}</div>
                                <div v-if="result.source === 'API_BANK'" class="badge badge-warning">{{$t("realEstate.createType.api_bank")}}</div>
                                <div v-if="result.source === 'EXPERT2'" class="badge badge-primary">{{$t("realEstate.createType.expert2")}}</div>
                                <div v-if="result.source === 'API_EXARID'" class="badge badge-warning">{{$t("realEstate.createType.api_exarid")}}</div>
                                <div v-if="result.source === 'REAL_SOFT'" class="badge badge-warning">{{$t("realEstate.createType.real_soft")}}</div>
                                <div v-if="result.source === 'API_E_MONITORING'" class="text-secondary">{{$t("realEstate.createType.apiEMonitoring")}}</div>
                                <div v-if="result.orderId" class="text-secondary font-weight-bold">{{result.orderId}}</div>
                                <div v-if="result.expert2Id" class="text-secondary font-weight-bold">{{result.expert2Id}}</div>
                              </td>
                              <td width="10%" class="text-secondary">
                                <div v-if="result.province">{{result.province.name}}</div>
                                <div v-if="result.region"> {{result.region.name}}</div>
                                <div>
                                  <span>{{result.address}} </span>
                                </div>
                              </td>
                              <td width="15%" class="text-center">
                                <template>
                                  <div v-if="result.approachCost">
                                    {{$t("realEstate.approach.expense")}}
                                    <br>
                                    <span class="font-weight-bold text-gray" v-if="result.coordination && result.coordination.expense && result.coordination.expense">
                                                {{calculateCoordination(result).expense.amount | currency('', 2, { thousandsSeparator: ' ' })}} сўм
                                            </span>
                                  </div>
                                  <div v-if="result.approachIncome">
                                    {{$t("realEstate.approach.income")}}
                                    <br>
                                    <span class="font-weight-bold text-gray" v-if="result.coordination && result.coordination.expense && result.coordination.expense">
                                                {{calculateCoordination(result).income.amount | currency('', 2, { thousandsSeparator: ' ' })}} сўм
                                            </span>
                                  </div>
                                  <div v-if="result.approachComparative">
                                    {{$t("realEstate.approach.comparative")}}
                                    <br>
                                    <span class="font-weight-bold text-gray" v-if="result.coordination && result.coordination.expense && result.coordination.expense">
                                                {{calculateCoordination(result).comparison.amount | currency('', 2, { thousandsSeparator: ' ' })}} сўм
                                            </span>
                                  </div>
                                </template>
                              </td>
                              <td width="10%">
                                <template>
                                  <div v-if="result.landComparisonEnabled && result.newLandComparison && result.newLandComparison.totalPrice > 0">
                                    {{result.newLandComparison.totalPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм
                                  </div>
                                  <div v-else-if="result.landLeaseEnabled && result.landLeaseData && result.landLeaseData.rentAmount > 0">
                                    {{result.landLeaseData.rentAmount | currency('', 2, { thousandsSeparator: ' ' })}} сўм
                                  </div>
                                </template>
                              </td>
                              <td width="10%">
                                <div v-if="result.newComparison && result.newComparison.totalPrice > 0">
                                  {{result.newComparison.totalPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм
                                </div>
                              </td>
                              <td width="15%" class="text-center ">
                                  <span v-if="result.coordination">{{result.coordination.total | currency('', 2, { thousandsSeparator: ' ' })}} сўм</span>
                              </td>
                              <td>
                                <button class="all-btn add-btn btn-sm"
                                        @click="changeStatus('Evaluated',result)"
                                        v-if="result.status === 'NotFullyEvaluated' && hasPermission('REAL_ESTATE_EVALUATE')"
                                        :disabled="loadEspAppraiser"
                                >
                                  {{$t("realEstate.action.confirm")}}
                                </button>
                                <div class="text-success" v-if="result.appraiserReportEsp">
                                  <b>{{$t("realEstate.field.evaluatorEspConfirmed")}}</b>
                                  <p class="text-secondary">{{new Date(result.appraiserReportEsp.createDate) | dateFormat('DD.MM.YYYY HH:mm')}}</p>
                                </div>
                              </td>
                              <td>
                                <button class="all-btn add-btn btn-sm"
                                        @click="changeStatus('Confirmed',result)"
                                        v-if="hasPermission('REAL_ESTATE_CONFIRM') && (result.status === 'Evaluated' || (result.status === 'Confirmed' && !result.directorReportEsp))"
                                        :disabled="loadEspDirector"
                                >
                                  {{$t("realEstate.action.confirm")}}
                                </button>
                                <div class="text-success" v-if="result.directorReportEsp">
                                  <b>{{$t("realEstate.field.directorEspConfirmed")}}</b>
                                  <p class="text-secondary">{{new Date(result.directorReportEsp.createDate) | dateFormat('DD.MM.YYYY HH:mm')}}</p>
                                </div>
                              </td>
                              <td class="td-actions text-center">
                                <router-link :to="'/new-real-estate-plus/view/' + result.id"
                                             v-tooltip="'Кўчмас мулк деталлари'"
                                             class="all-btn view-btn table-action"
                                             v-if="hasPermission('NEW_REAL_ESTATE_VIEW')">
                                  <i class="fa fa-image"></i>
                                </router-link>
                                <router-link :to="result.type === 'BUILDING' ? '/real-estate-evaluation/edit/' + result.id : '/new-real-estate-plus/edit/' + result.id"
                                             v-tooltip="'Кўчмас мулкни ўзгартириш'"
                                             class="all-btn edit-btn table-action"
                                             v-if="hasPermission('NEW_REAL_ESTATE_EDIT')">
                                  <i class="fa fa-edit"></i>
                                </router-link>
                                <!--                                    <button class="all-btn view-btn table-action"-->
                                <!--                                            v-tooltip="'Тўлов қўшиш'">-->
                                <!--                                        <i class="fa fa-credit-card"></i>-->
                                <!--                                    </button>-->
                                <button class="all-btn delete-btn table-action"
                                        v-if="(result.status !== 'Evaluated' && result.status !== 'Confirmed') && hasPermission('NEW_REAL_ESTATE_DELETE')"
                                        v-tooltip="'Кўчмас мулкни ўчириш'"
                                        @click="deletedRealEstate(result.id)"
                                >
                                  <i class="fa fa-remove"></i>
                                </button>
                                <button class="all-btn edit-btn table-action"
                                        v-if="result.status === 'NotFullyEvaluated' && hasPermission('REAL_ESTATE_COMPARATIVE_ERROR_VIEW')"
                                        v-tooltip="'Тезлик ва хатолик аниқлаш'"
                                        @click="onShowComparativeErrorCalculateModal(result.id)"
                                >
                                  <i class="fa fa-warning"></i>
                                </button>
                                <button class="all-btn view-btn table-action"
                                        v-if="result.status === 'Confirmed' && !result.bitrix24DealId && hasPermission('NEW_REAL_ESTATE_SEND_TO_BITRIX24')"
                                        v-tooltip="'Битрикс24 га юбориш'"
                                        :disabled="processing"
                                        @click="onToSendBitrix24(result.id)"
                                >
                                  <i class="fa fa-send-o"></i>
                                </button>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="text-center">
                            <div class="loader mt-5 mb-5" v-if="loading"></div>
                            <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length === 0">{{$t("messages.list.empty")}}</span>
                        </div>
                        <div class="row" v-if="!loading && results && results.total && results.total > 1">
                            <div class="col-12 pt-3 pb-3">
                                <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <NewRealEstateActModal></NewRealEstateActModal>
        <AppraiserEspModal></AppraiserEspModal>
        <DirectorEspModal></DirectorEspModal>
        <NewRealEstateSurveyModal></NewRealEstateSurveyModal>
        <CadastreFixErrorModal :error-msg="cadasteErrorMsg" :request-id="realEstate && realEstate.requestId" :evl-object-type="'Building'" @handle-success="handleFixErrorSuccess"/>
        <ComparativeErrorCalculateModal />
    </div>
</template>

<script>
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import initFilterModel from '@/shared/filter';
    import {EVL_GOAL_TYPES, EVL_PROPERTY_TYPES} from '@/shared/constants/realEstate'
    import NewRealEstateActModal from '@/views/real-estate/new/NewRealEstateActModal'
    import AppraiserEspModal from '@/views/real-estate/new/NewRealEstateAppraiserReportEspModal'
    import DirectorEspModal from '@/views/real-estate/new/NewRealEstateDirectorReportEspModal'
    import NewRealEstateSurveyModal from '@/views/real-estate/new/NewRealEstateSurveyModal'
    import AdvancedFilter from '@/shared/filters/advancedFilter';
    import DatePicker from "vuejs-datepicker";
    import CadastreFixErrorModal from "@/components/cadastre/CadastreFixErrorModal.vue";
    import ComparativeErrorCalculateModal from "@/components/real-estate/ComparativeErrorCalculateModal.vue";
    import CadastreInput from "@/components/CadastreInput.vue";

    export default {
        name: "NewRealEstatePlusList",
        components: {
          CadastreInput,
            CadastreFixErrorModal,
            'b-pagination': bPagination,
            NewRealEstateActModal,
            AppraiserEspModal,
            DirectorEspModal,
            NewRealEstateSurveyModal,
            DatePicker,
            ComparativeErrorCalculateModal
        },
        data() {
            return {
                loading: false,
                loadEspAppraiser: false,
                loadEspDirector: false,
                processing: false,
                filter: {
                  ...initFilterModel(),
                  cadastreDocNumber: null,
                  sourceByFilter: null
                },
                filterBuildingType: new AdvancedFilter(),
                results: null,
                goalTypes: EVL_GOAL_TYPES,
                propertyTypes: EVL_PROPERTY_TYPES,
                specialComfort: null,
                specialComforts: [],
                architecturalStyles: [],
                repairConditions: [],
                buildingTypes: [],
                subBuildingTypes: [],
                microRegions: [],
                province: null,
                region: null,
                provinces: [],
                regions: [],
                filterProvince: initFilterModel(),
                filterRegion: initFilterModel(),
                filterStartDate: null,
                filterEndDate: null,
                realEstate: null,
                cadasteErrorMsg: 'Ушбу мулкка оид кадастр маълумотлари топилмади!',
                sourceByFilter: null,
                multipleReportSignDto: {
                    espType: null,
                    evlObjectType: "Building",
                    espUUID: null
                }
            }
        },
        computed: {
            addRealEstateUrl() {
                if (this.$route.meta && this.$route.meta.category && this.$route.meta.category === 'Residential') {
                    return '/real-estate-plus/residential/new';
                } else {
                    return '/real-estate-plus/notorious/new';
                }
            },
            showButtons() {
              return process.env.VUE_APP_NAME === 'production' || process.env.VUE_APP_NAME === 'dev'
            },
            canSignDirectorEsp() {
              return this.showButtons && this.$store.state.profile.authorities.includes('ROLE_DIRECTOR') && this.hasPermission('REAL_ESTATE_CONFIRM')
            }
        },
        methods: {
            initList() {
                this.loading = true;
                if (this.$route.meta && this.$route.meta.category) {
                    this.filter.category = this.$route.meta.category;
                }
                // if (this.filter.search.length > 0) this.filter.page.page = 1;
                this.filter.realEstateVersion = "V3";
                this.filter.startDate = null
                this.filter.endDate = null
                this.filter.source = 'INSIDE'

                if(this.filterStartDate) {
                  this.filter.startDate = new Date(this.filterStartDate.getFullYear(), this.filterStartDate.getMonth(), this.filterStartDate.getDate() + 1);
                  this.filter.startDate.setUTCHours(0, 0, 0, 0);
                }
                if(this.filterEndDate) {
                  this.filter.endDate = new Date(this.filterEndDate.getFullYear(), this.filterEndDate.getMonth(), this.filterEndDate.getDate() + 2);
                  this.filter.endDate.setUTCHours(0, 0, 0, 0);
                }

                this.filter.sourceByFilter = this.sourceByFilter ? this.sourceByFilter : null;

                this.$http.post('admin/new-real-estate/list', this.filter)
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            initBuildingTypes() {
                if (!this.buildingTypes.length) {
                    this.$http.post('building-type/list', {search: '', onlyParentLookUp: true})
                        .then(res => {
                            if (res.data !== "" && res.data.data.length > 0) {
                                this.buildingTypes = res.data.data;
                            }
                        }, err => {
                            console.log(err);
                        });
                }
            },
            initSubBuildingTypes(realEstate, parentId) {
                if (!this.subBuildingTypes.length && parentId) {
                    this.filterBuildingType.cadastreType = realEstate.category
                    this.filterBuildingType.parent = parentId
                    this.filterBuildingType.onlyParentLookUp = false

                    this.$http.post('building-type/list', this.filterBuildingType)
                        .then(res => {
                            if (res.data !== "" && res.data.data.length > 0) {
                                this.subBuildingTypes = res.data.data;
                            }
                        }, err => {
                            console.log(err);
                        });
                }
            },
            getBuildingType(realEstate) {
                const type = this.buildingTypes.filter(b => b.code === realEstate.buildingType)[0];
                if (type) {
                    if (realEstate.subBuildingType) {
                        this.initSubBuildingTypes(realEstate, type.id);
                    }
                    return type.name;
                }
                return ''
            },
            onMicroRegion(realEstate) {
                this.microRegions = [];
                this.filterMicroRegion.region = (realEstate.region && realEstate.region.id) ? realEstate.region.id : 0;
                this.$http.post('/uy-joy-api/micro-regions', this.filterMicroRegion.asQuery())
                    .then(res => {
                        this.microRegions = res.data.data;
                        const type = this.microRegions.filter(b => b.id === realEstate.microRegionId)[0];
                        if (type) {
                            return '/ '  + type.name;
                        }
                        return ''
                    }, err => {
                        console.log(err);
                    });
            },
            getSubBuildingType(realEstate) {
                const type = this.subBuildingTypes.filter(b => b.code === realEstate.subBuildingType)[0];
                if (type) {
                    return '/ '  + type.name;
                }
                return ''
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            deletedRealEstate(id) {
                this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: this.$t('messages.realEstate.deleteConfirm'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#dd3333',
                    confirmButtonText: 'Ўчириш',
                    cancelButtonText: 'Бекор қилиш'
                    // cancelButtonColor: '#dd3333'
                }).then((result) => {
                    if (result.value) {
                        this.$http.delete('admin/new-real-estate/' + id)
                            .then((res) => {
                                if (res && res.data && res.data.status === 'SUCCESS') {
                                    this.$swal({
                                        title: this.$t('messages.common.success'),
                                        text: this.$t('messages.realEstate.deleteSuccess'),
                                        type: 'success'
                                    });
                                    this.initList();
                                } else {
                                    this.$swal({
                                        title: this.$t('messages.common.warning'),
                                        text: res.data.message,
                                        type: 'warning'
                                    });
                                }
                                this.processing = false;
                            }, () => {
                                this.$swal({
                                    title: this.$t('messages.common.error'),
                                    text: this.$t('messages.realEstate.deleteError'),
                                    type: 'error'
                                });
                                this.processing = false;
                            });
                    }
                });
            },
            onChangeStatus() {
                this.filter.page.page = 1;
                this.initList()
            },
            getGoalType(type) {
                const goals = this.goalTypes.filter((t) => t.key === type);
                return goals.length > 0 ? goals[0].name : '';
            },
            calculateCoordination(result) {
                const coordination = result.coordination;
                coordination.expense.total = (coordination.approachCost ? (result.coordination.expense.amount * result.coordination.expense.factorAverage) : 0);
                coordination.comparison.total = (coordination.approachComparative ? (result.coordination.comparison.amount * result.coordination.comparison.factorAverage) : 0);
                coordination.income.total = (coordination.approachIncome ? (result.coordination.income.amount * result.coordination.income.factorAverage) : 0);

                if (result.type === 'BASIC') {
                  coordination.total = coordination.expense.total + coordination.comparison.total + coordination.income.total;
                }

                return coordination;
            },
            viewRealEstateAct(id) {
                this.$eventBus.$emit('showBuildingActModal',id);
            },
            viewRealEstateSurvey(realEstate) {
                this.$eventBus.$emit('showBuildingSurveyModal', realEstate)
            },
            handleChangeLand(e, result) {
                const realEstate = result;
                const name = e.target.name;
                if (realEstate[name]) {
                    Object.keys(realEstate).map((key) => {
                        if (key !== name) {
                            if (key === 'landComparisonEnabled' || key === 'landLeaseEnabled') {
                                realEstate[key] = false;
                            }
                        }
                    })
                }

                this.loading = true;
                this.$http.post('admin/new-real-estate/land-enabled/change', realEstate)
                    .then(res => {
                        this.loading = false;
                        if (res.data.status === "ERROR") {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: res.data.message,
                                type: 'warning'
                            });
                            return;
                        }
                        this.$router.go(0);
                    });
            },
            getCoordination(id) {
                return this.$http.get('admin/new-real-estate/coordination/' + id);
            },
            changeStatus(status, realEstate) {
                if (status === 'Evaluated') {
                    this.loadEspAppraiser = true;

                    this.getCoordination(realEstate.id).then((res) => {
                        const coordination = res.data.coordination;
                        let errorTxt = '';
                        if (realEstate.approachCost && coordination.expense.amount === 0) {
                            errorTxt = "Харажат"
                        }
                        if (realEstate.approachIncome && coordination.income.amount === 0) {
                            if (errorTxt.length > 0) errorTxt += ', ';
                            errorTxt += "Даромад"
                        }
                        if (realEstate.approachComparative && coordination.comparison.amount === 0) {
                            if (errorTxt.length > 0) errorTxt += ', ';
                            errorTxt += "Киёсий"
                        }

                        if (errorTxt.length > 0) {
                            errorTxt += " хисоб-китоб килинмаган!";
                            this.$swal({
                                title: this.$root.$t('messages.common.warning'),
                                text: errorTxt,
                                type: 'warning'
                            });
                        } else this.$router.push({ path: '/new-real-estate/coordination/' + realEstate.id + '/' + true, query: {isEdit: false}});
                    });

                    this.loadEspAppraiser = false;

                } else if (status === 'Confirmed') {
                    this.changeStatusGo(status, realEstate);
                }
            },
            changeStatusGo(status, realEstate) {
                this.loadEspDirector = true;
                this.$http.post('admin/new-real-estate/status', {
                    realEstateId: realEstate.id,
                    status: status,
                }).then(res => {
                    if (res && res.data && res.data.status === 'SUCCESS') {
                        this.$swal({
                            title: this.$root.$t('messages.common.success'),
                            text: this.$root.$t('messages.realEstate.statusSuccess'),
                            type: 'success'
                        });
                        if (status === 'Confirmed' && realEstate.hasEsp && realEstate.appraiserReportEsp) {
                            this.showDirectorEsp(realEstate.id)
                        }
                    } else {
                        this.$swal({
                            title: this.$root.$t('messages.common.warning'),
                            text: this.$root.$t('messages.realEstate.statusWarning'),
                            type: 'warning'
                        });
                    }
                    this.loadEspDirector = false;
                }, () => {
                    this.$swal({
                        title: this.$root.$t('messages.common.error'),
                        text: this.$root.$t('messages.realEstate.statusError'),
                        type: 'error'
                    });
                    this.loadEspDirector = false;
                });
            },
            // showAppraiserEsp(realEstateId) {
            //     this.$eventBus.$emit('showRealEstateAppraiserEspModal',realEstateId)
            // },
            showDirectorEsp(realEstateId) {
                this.$http.get(`esign/director/${realEstateId}/Building`)
                    .then(res => {
                        if (res.data && res.data.status === 'SUCCESS') {
                          // console.log("res.data = ", res.data)
                            window.open(res.data.data, '_blank');
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: res.data.message,
                                type: 'warning'
                            });
                        }
                    }, err => {
                        console.log(err);
                    })
            },
            canSave(realEstate) {
                return (realEstate.status === 'Pending' || realEstate.status === 'AssignedToEvaluator' || realEstate.status === 'NotFullyEvaluated');
            },
            onChangeFilterProvince() {
              if (this.regions.length) this.regions = [];
              if (this.region) this.region = null
              this.filter.region = null
              this.filter.province = null

              if (this.province) {
                this.filter.province = this.province.code
              }

              this.initList();
            },
            onChangeFilterRegion() {
              if (this.region) {
                this.filter.region = this.region.code
                this.initList();
              }
            },
            onProvinceFocus() {
              this.provinces = [];
              this.filterProvince.search = '';
              this.$http.post('/province/list', this.filterProvince)
                  .then(res => {
                    this.provinces = res.data.data;
                  }, err => {
                    console.log(err);
                  });
            },
            onProvinceSearch(searchTxt, loading) {
              loading(true);
              this.provinces = [];
              this.filterProvince.search = searchTxt;
              this.$http.post('/province/list', this.filterProvince)
                  .then(res => {
                    this.provinces = res.data.data;
                    loading(false);
                  }, err => {
                    console.log(err);
                  });
            },
            onRegionSearch(searchTxt, loading) {
              loading(true);
              this.regions = [];
              this.filterRegion.search = searchTxt;
              this.filterRegion.provinceId = (this.province && this.province.id) ? this.province.id : 0;
              this.$http.post('/region/search', this.filterRegion)
                  .then(res => {
                    this.regions = res.data.data;
                    loading(false);
                  }, err => {
                    console.log(err);
                  });
            },
            onRegionFocus() {
              this.regions = [];
              this.filterRegion.provinceId = (this.province && this.province.id) ? this.province.id : 0;
              this.$http.post('/region/search', this.filterRegion)
                  .then(res => {
                    this.regions = res.data.data;
                  }, err => {
                    console.log(err);
                  });
            },
            getAndSendFixError(realEstate) {
              this.realEstate = realEstate
              if (realEstate.data.values.hasOwnProperty('fixErrorDataResponse')) {
                this.getFixError(realEstate)
              } else {
                this.$eventBus.$emit('showCadastreFixErrorModal', realEstate);
              }
            },
            getFixError(realEstate) {
              this.processing = true;
              this.$http.get('v3/real-estate/get-fix-error/' + realEstate.uuid)
                  .then(res => {
                    let resData = res.data;
                    if (resData.status === 'SUCCESS' && resData.data) {
                      let status = "ЯНГИ"
                      let type = 'info'
                      if (resData.data.processStatus === 'DONE') {
                        status = this.$t("realEstate.status.confirmed")
                        type = 'success'

                        if (this.isCadastreFixError(realEstate)) {
                          let responseFixError = resData.data;
                          responseFixError.requestId = realEstate.requestId

                          this.saveFixError(responseFixError)
                        }
                      } else if (resData.data.processStatus === 'IN_PROGRESS') {
                        status = this.$t("realEstate.status.notFullyEvaluated")
                      } else if (resData.data.processStatus === 'REJECT') {
                        status = this.$t("realEstate.status.rejected")
                        type = 'warning'
                      }

                      this.$swal({
                        title: this.$t('messages.common.success'),
                        text: status,
                        type: type
                      });
                    }
                    this.processing = false;

                  }).catch(({response}) => {
                console.log('error')
                console.log(response)

                this.$swal({
                  type: 'error',
                  title: '',
                  text: response.data.message ? response.data.message : response.data
                });

                this.processing = false;
              })
            },
            saveFixError(responseFixError) {
              this.processing = true;
              this.$http.post('v3/real-estate/save-fix-error', responseFixError)
                  .then(res => {
                    console.log(res)
                    this.processing = false;
                    this.initList()

                  }).catch(({response}) => {
                console.log('error')
                console.log(response)

                this.$swal({
                  type: 'error',
                  title: '',
                  text: response.data.message ? response.data.message : response.data
                });

                this.processing = false;
              })
            },
            handleFixErrorSuccess() {
              this.initList()
            },
            onShowComparativeErrorCalculateModal(id) {
              this.processing = true;
              this.$http.get('admin/new-real-estate/finding-comparative-errors/' + id,)
                  .then(res => {
                    if (res.data && res.data.data) {
                      this.$eventBus.$emit('showComparativeErrorCalculateModal', res.data.data);
                    }
                    this.processing = false;

                  }).catch(({response}) => {
                console.log('error')
                console.log(response)

                this.$swal({
                  type: 'error',
                  title: '',
                  text: response.data.message ? response.data.message : response.data
                });

                this.processing = false;
              })
            },
            onToSendBitrix24(id) {
              this.processing = true;
              this.$http.get('bitrix24/' + id + '/' + 'DB_REAL_ESTATE',)
                  .then(res => {
                    if (res.status === 200) {
                      this.initList()
                    }
                    console.log('bitrix24 = ', res)

                    this.processing = false;

                  }).catch(({response}) => {
                    console.log('error')
                    console.log(response)

                    this.$swal({
                      type: 'error',
                      title: '',
                      text: response.data.message ? response.data.message : response.data
                    });

                    this.processing = false;
              })
            },
            ownerName(data) {
              let owner;
              if (data.customer) {
                owner = data.customer
              } else {
                owner = data.owner
              }

              if (owner && owner.type && owner.type === 'Legal') {
                return "<b>" + (owner.firmName ? owner.firmName : " ") + "</b>" + "<br>" + (owner.fullName ? owner.fullName : " ")
              } else {
                return owner && owner.fullName ? owner.fullName : " "
              }
            },
            isCadastreFixError(realEstate) {
              return  realEstate.data && realEstate.data.values && (realEstate.data.values.getNewCadastre || realEstate.data.values.isCadastreError)
            },
            handleSignDirectorEsp() {
              this.multipleReportSignDto.espType = 'DIRECTOR_SIGN_REPORT'
              this.handleSignReports()
            },
            async handleSignReports() {
              await this.getRandomUUID();

              let res = await this.$http.post('multiple/confirm/url', this.multipleReportSignDto)
              if(res && res.data && res.data.data && this.multipleReportSignDto.espUUID) {
                this.sendEncryptedMessage(res.data.data);
              }
            },
            async getRandomUUID() {
              try {
                let res = await this.$http.get('common/generate-random-uuid')
                if(res && res.data) {
                  this.multipleReportSignDto.espUUID = res.data
                }
              } catch (err) {
                console.error(err)
                this.multipleReportSignDto.espUUID = null
              }
            },
            sendEncryptedMessage(resData) {
              if(resData && resData.url && resData.id) {
                let normalizedPath = this.$route.path.replace('/', '')
                let backUrl = `${process.env.VUE_APP_WEB_URL}${normalizedPath}`
                let url = new URL(resData.url)
                url.searchParams.set('id', resData.id)
                url.searchParams.set('backUrl', backUrl)
                window.open(url.toString(), '_blank', 'noopener,noreferrer');
              }
            }
        },
        watch:{
            $route (to, from){
                console.log(to);
                console.log(from);
                this.initList();
            }
        },
        created() {
            this.filterProvince.page.size = 1000;
            this.filterRegion.page.size = 1000;

            this.initBuildingTypes()
            this.initList();
        }
    }
</script>

<style scoped>
    .table .form-check .form-check-sign, .table .form-check .form-check-sign:before, .table .form-check .form-check-sign:after {
        margin-top: 0;
    }

    .table p {
        font-size: 0.9rem;
    }
</style>
